/* eslint-disable react-hooks/rules-of-hooks */
import requester from '@/utils/requester';
import { message } from 'antd';
import { StateCreator, create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';

interface IGlobalState {
  tags?: any;
  emrTypes?: Record<string, IEMRType>;
  phrConfigs?: IPhrConfig;
  errorMessage?: string;
  isLoading?: boolean;
  refetchPHR?: Function;
  refetchTimeline?: Function;
  refetchBody?: Function;
  refetchCountBody?: Function;

  getListCreateEMRs: () => IEMRType[];
  getEmrType: (codeEmrType: string) => IEMRType;
  getEmrGroups: () => string[];
  getEmrViewTimeline: () => string[];
  getBodyScreenConfig: () => IBodyScreen[];
  getConfigs: () => void;
  setRefetchPHR: (f: Function) => void;
  setRefetchBody: (f: Function) => void;
  setRefetchCountBody: (f: Function) => void;
  setRefetchTimeline: (f: Function) => void;
}

const initState = {
  refetchPHR: undefined,
  refetchBody: undefined,
  refetchCountBody: undefined,
  refetchTimeline: undefined,
  emrTypes: undefined,
  phrConfigs: undefined,
  errorMessage: undefined,
};
export const getSub = (emrType: IEMRType, emrTypes: Record<string, IEMRType>) => {
  emrType.fields = {};
  emrType.extra = { ...Function(emrType.extraFunction)() };

  emrType.format.fields.map((f: IFieldConfig, i: number) => {
    f.index = i;
    f.extra = { ...Function(f.extraFunction)(), ...f.extra };

    if (emrTypes[f.emrType]) {
      f.emr = JSON.parse(JSON.stringify(emrTypes[f.emrType]));

      const listFieldRaw = [...f.emr.format.fields];

      const objCustomFields = f.extra?.fields?.reduce((d: any, e: any) => {
        if (typeof e === 'string') {
          d[e] = { key: e };
        } else {
          d[e.key] = e;
        }
        return d;
      }, {});

      f.emr.format.fields = f.extra?.fields?.length
        ? listFieldRaw.filter((f) => {
            if (objCustomFields[f?.key]) {
              // ưu tiên merge extra
              if (objCustomFields[f.key]?.extra && typeof objCustomFields[f.key]?.extra === 'object') {
                f.extra = f.extra || {};
                Object.assign(f?.extra, objCustomFields[f.key]?.extra);
              }
              // sau đó merge các config
              Object.assign(f, objCustomFields[f.key]);
            }
            return Object.keys(objCustomFields)?.includes(f.key);
          })
        : listFieldRaw;

      //   if (emrType.code === 'hearthRate') console.log(emrType.format);

      if (f.emr) getSub(f.emr, emrTypes);
    }
  });
};

const useGlobalConfigs = create<IGlobalState>(
  devtools(
    persist(
      (set, get) => {
        return {
          ...initState,

          async getConfigs() {
            try {
              // Lấy danh sách emrType
              const emrTypeResponse = await requester.get(`/phr/v1/emr-types`, { params: { limit: 10e3 } });
              const configs: Record<string, IEMRType> = emrTypeResponse?.data?.reduce(
                (data: any, element: IEMRType) => {
                  element.extra = { ...Function(element.extraFunction)(), ...element.extra };
                  data[element.code] = element;
                  return data;
                },
                {},
              );
              if (!configs) {
                //   this.getConfigs();
              } else {
                Object.values(configs).forEach((emrType) => getSub(emrType, configs));
                window.emrTypes = configs;

                // Lấy phrConfigs
                const configsResponse = await requester.get(`/center/v1/configs?key=phr_config`);

                const phrConfigs: IPhrConfig = configsResponse?.data?.value
                  ? Function(configsResponse?.data?.value)()
                  : undefined;

                set((state) => ({ ...state, emrTypes: configs, phrConfigs }));
              }
            } catch (error: any) {
              message.error(error.message);
            }
          },

          setRefetchPHR(f) {
            set((s) => ({ ...s, refetchPHR: f }));
          },
          setRefetchBody(f) {
            set((s) => ({ ...s, refetchBody: f }));
          },
          setRefetchCountBody(f) {
            set((s) => ({ ...s, refetchCountBody: f }));
          },
          setRefetchTimeline(f) {
            set((s) => ({ ...s, refetchTimeline: f }));
          },

          getEmrType(codeEmrType: string) {
            return get().emrTypes?.[codeEmrType] as IEMRType;
          },

          getEmrViewTimeline() {
            return get()?.phrConfigs?.viewTimeline || [];
          },

          getBodyScreenConfig() {
            console.log('🚀 ~ file: globalConfigs.ts:146 ~ getBodyScreenConfig ~ get():', get());
            return (get()?.phrConfigs?.body || get()?.phrConfigs?.bodySystem) as IBodyScreen[];
          },

          getEmrGroups() {
            const emrTypes = get().emrTypes;

            return Object?.values(emrTypes || {})?.reduce((d: string[], e: IEMRType) => {
              if (e?.extra?.timeline?.isGroup) {
                d = [...d, e.code];
              }
              return d;
            }, []);
          },

          getListCreateEMRs() {
            const keys = get().phrConfigs?.createEMRs;
            console.log('🚀 ~ file: globalConfigs.ts:161 ~ getListCreateEMRs ~ keys:', keys);
            const emrTypes = get().emrTypes;
            const result = keys?.map((k) => emrTypes?.[k]).filter(Boolean) as IEMRType[];
            return result;
          },
        };
      },
      {
        name: 'global-configs-storage',
        storage: createJSONStorage(() => localStorage),
      },
    ),
    { name: 'global-configs' },
  ) as StateCreator<IGlobalState>,
);

export default useGlobalConfigs;
